import React from 'react';
import Navbar from '../components/Navbar';
import Headings from '../components/Headings';
import InfoBlock from '../components/InfoBlock';
import CtaBanner from '../components/CtaBanner';
import Footer from '../components/Footer';

const Windows = () => {
  return (
    <>
      <Navbar />
      <Headings headingName="Windows" />
      <InfoBlock
        tagLine="Professional Window Installation & Replacement"
        simpleText="Enhance your home's energy efficiency and curb appeal with our expert window installation services."
      />
      <CtaBanner />
      <Footer />
    </>
  );
};

export default Windows;
